import { apiService } from './api/api';
import { API_ENDPOINTS } from '../constants/api';
import {
  CreateReservationRequestDto,
  PagedReservationResponseDto,
  ReservationResponseDto,
} from '../types/reservation';

class ReservationService {
  async createReservation(data: CreateReservationRequestDto): Promise<ReservationResponseDto> {
    return await apiService.post<ReservationResponseDto>(API_ENDPOINTS.RESERVATIONS.CREATE, data);
  }
  
  async getMyReservations(
    page = 1,
    limit = 10,
    status?: string
  ): Promise<PagedReservationResponseDto> {
    const params: Record<string, string> = {
      page: String(page),
      limit: String(limit),
    };
    if (status) params.status = status;
    const query = new URLSearchParams(params).toString();
    return await apiService.get<PagedReservationResponseDto>(`${API_ENDPOINTS.RESERVATIONS.ME}?${query}`);
  }

  async getReservationById(id: string): Promise<ReservationResponseDto> {
    return await apiService.get<ReservationResponseDto>(`${API_ENDPOINTS.RESERVATIONS.GET}/${id}`);
  }

  async getReservationByCode(code: string): Promise<ReservationResponseDto> {
    return await apiService.get<ReservationResponseDto>(API_ENDPOINTS.RESERVATIONS.GET_BY_CODE.replace(':code', code));
  }

  async cancelReservation(id: string, reason?: string): Promise<ReservationResponseDto> {
    return await apiService.patch<ReservationResponseDto>(API_ENDPOINTS.RESERVATIONS.CANCEL.replace(':id', id), { reason });
  }

  async reportIssue(id: string, details: string): Promise<ReservationResponseDto> {
    return await apiService.post<ReservationResponseDto>(API_ENDPOINTS.RESERVATIONS.REPORT_ISSUE.replace(':id', id), { details });
  }

  async updateReservationStatus(id: string, status: string): Promise<ReservationResponseDto> {
    return await apiService.patch<ReservationResponseDto>(`${API_ENDPOINTS.RESERVATIONS.GET}/${id}`, { status });
  }

  async checkAvailability(equipmentId: string, from: string, to: string): Promise<{ available: boolean }> {
    const params = new URLSearchParams({ equipmentId, from, to }).toString();
    return await apiService.get<{ available: boolean }>(`${API_ENDPOINTS.RESERVATIONS.AVAILABILITY}?${params}`);
  }
}

export const reservationService = new ReservationService();
